import type { FunctionComponent, PropsWithChildren } from "react";

const SidebarFooter: FunctionComponent<PropsWithChildren> = ({ children }) => (
	<div className="flex justify-end gap-x-2 bg-white px-7 py-5"
		 style={{ boxShadow: "0 0 4px 0 rgba(0,0,0,.2)" }}>
		{children}
	</div>
);
export default SidebarFooter;